import { AlertServiceService } from './../../../api-module/services/alertservice/alert-service.service';
import { Component, HostListener, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Message } from 'primeng/api';
const NOTIFICATION_KEY: string = 'CACHED_NOTIFICATION';

@Component({
    selector: 'app-recieve-call-alert-component',
    templateUrl: './recieve-call-alert-component.html',
    styleUrls: ['./recieve-call-alert-component.css']
})
export class RecieveCallAlertComponentComponent implements OnDestroy {
    private subscription: Subscription;
    phone: any;
    isShown: boolean = false;
    closeIcon: boolean = false;
    message: {
        text: string,
        type: string
    }
    msgs: Message[];
    constructor(private alertService: AlertServiceService, private router: Router,) {
        // subscribe to alert messages
        this.subscription = alertService.getMessage().subscribe(message => { this.message = message; });
        this.alertService.OnReciveCall.subscribe(data => {
            if (data) {
                console.log('data ... ', data);

                this.isShown = true;
                this.phone = data;
                this.message = {
                    text: data,
                    type: "warn"
                }

                localStorage.setItem(NOTIFICATION_KEY, JSON.stringify(data));
            }
        })
        //  this.subscription = alertService.OnReciveCall().subscribe(message => { this.message = message; });        
    }

    ngOnInit() {
        this.msgs = [
            { severity: 'warn', summary: 'Recieve Call', detail: 'A New Call Is Recieved Click Here To View It'
           }
        ];
    }

    clear() {
    }

    NavigateToCustomerSearchPage(): void {
        let newRelativeUrl = this.router.createUrlTree(['customer/customersearch'], { queryParams: { SearchVal: this.phone } });
        let baseUrl = window.location.href.replace(this.router.url, '');
        window.open(baseUrl + newRelativeUrl, '_blank');
        this.isShown = false;
        localStorage.setItem(NOTIFICATION_KEY, "yes");
    }

    @HostListener('window:storage', ['$event'])
    onStorageChange(event: StorageEvent) {
        if (event.key === 'CACHED_NOTIFICATION' && event.newValue === "yes") {
            this.msgs.length = 0;
            this.isShown = false;
        }
    }

    ngOnDestroy(): void {
        // unsubscribe on destroy to prevent memory leaks
        this.subscription.unsubscribe();
    }
}